import { useState } from "react";

import { Button } from "../../Button";
import { Input } from "../../Input";
import { Container, Title, Description } from "./styles";

export function WorkWithUsContent() {
  const [email, setEmail] = useState("");
  const [applied, setApplied] = useState(false);

  const onApply = () => setApplied(true);
  const onCancel = () => setApplied(false);

  if (applied)
    return (
      <Container>
        <Title>Thank your for applying.</Title>
        <Description>
          Description for the applied state of the Work With Us component
        </Description>
        <Button color="#cc0000" onClick={onCancel}>
          Cancel application
        </Button>
      </Container>
    );

  return (
    <Container>
      <Title>Come work with us</Title>
      <Description>
        Description for the NOT applied state of the Work With Us component
      </Description>
      <Input
        placeholder="Your e-mail*"
        button={{ label: "Start application", color: "#13BEBE" }}
        onSubmit={onApply}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
    </Container>
  );
}